import request from './request'
import { isObject } from '@/utils'

export function toAdvancedQuery(params, options = {}) {
    let {
        condition = '$eq',
        offset,
        limit,
        order
    } = options;

    let query = Object.keys(params).reduce((initState, key) => {
        let val = params[key];
        if (isObject(val) && !Array.isArray(val)) {
            return Object.assign(initState, {[key]: {[val.condition]: val.value}});
        } else {
            return Object.assign(initState, {[key]: {[condition]: val}});
        }
    }, {});

    return Object.assign({}, {query, offset, limit, order});
}

// 访客状态
export function getVisitorState(flag) {
    const state = {
        '0': '已取消',
        '1': '已访问',
        '2': '已访问',
        '3': '待访问',
        '4': '已过期',
        '5': '待审核',
        '6': '已拒绝',
        '7': '滞留中'
    }

    return state[flag];
}

// 状态访问中和访问后都改成了已访问，所以需要同时expired_time去判断是否已经过了访问时间
export function isExpiredInVisit(visitor) {
    const {state, expired_time_ioc} = visitor
    if (isInVisit(state)) {
        const expired = +new Date(expired_time_ioc)
        return expired < +(new Date().setHours(new Date().getHours() + 8))
    }
    return false
}

export function isInVisit(state) {
    return ['1', '2'].includes(state+'');
}

// 是否微信发起申请
export function isFromWeixin(type) {
    return type === 'meidiMicroMsg';
}

// 待审核
export function isNotConfirmed(state) {
    return parseInt(state) === 5;
}

// 已访问
export function isVisiting(state) {
    return parseInt(state) === 1;
}
// 已访问
export function isVisited(state) {
    return parseInt(state) === 2;
}

// 待访问
export function isNotVisit(state) {
    return parseInt(state) === 3;
}

// 是否有通行权限
export function hasAccessAuth(state) {
    return ['1', '2', '3'].includes(state+'');
}

export function isNegative(state) {
    return ['0', '4', '6', '7'].includes(state+'');
}

export function filterDateInPeriod(dayList, isWeek, start, end) {
    if (!dayList || !dayList.length) return []
    let start_time = new Date(start)
    let end_time = new Date(end)
    if (isWeek) {
        if ((end_time.getTime() - start_time.getTime()) /(1000*3600*24) > 7) return dayList
        let start_day = start_time.getDay()
        let end_day = end_time.getDay()
        return dayList.filter(item => {
            return Number(item)>=start_day && Number(item)<=end_day
        })
    } else {
        let list = [...dayList]
        let startDate = start_time.getDate()
        let startMon = start_time.getMonth()
        let endMon = end_time.getMonth()
        let endDate = end_time.getDate()
        if (startMon == endMon) {
            return list.filter(item => {
                return Number(item)>=startDate && Number(item)<=endDate
            })
        } else {
            return list.filter(item => {
                let date1 = new Date(`${start_time.getFullYear()}-${startMon+1}-${item}`)
                let date2 = new Date(`${start_time.getFullYear()}-${endMon+1}-${item}`)
                if (date1.getMonth() != startMon || date2.getMonth() != endMon) return false // 如果不存在的日期，Date会往后延，比如 2021-02-29 会变成 2021-03-01
                return (date1.getTime()>= start_time.getTime() && date1.getTime()<=end_time.getTime()) || (date2.getTime()>= start_time.getTime() && date2.getTime()<= end_time.getTime())
            })
        }
    }
}

// 是否周期访问
export function isPeriod(flag) {
    return parseInt(flag) === 2;
}

// 是否以每周方式进行周期访问
export function isWeekPeriodWay(flag) {
    return parseInt(flag) === 1
}

// 是否星期限制周期访问（周几能访问）
export function isWeekPeriod(auth_limit_week) {
    return Array.isArray(auth_limit_week) && (auth_limit_week.length > 0)
}

// 是否日期限制周期访问（每月哪号能访问）
export function isDayPeriod(auth_limit_days) {
    return Array.isArray(auth_limit_days) && (auth_limit_days.length > 0)
}


// 查询访客详情
export function queryVisitor(projectId, visitorId) {
    return new Promise((resolve, reject) => {
        request({
            url: `v2/smart-access/${projectId}/visitor/${visitorId}`,
            method: 'post',
            data: { 'method': 'GET' }
        }).then((visitor={}) => {




            if (!visitor.address) {

                if (visitor.employee_type == 1) { // 拜访业主
                    let houses = visitor.resident ? visitor.resident.houses : [];
                    let house_name = houses[0] ? houses[0].house_name : '';
                    visitor.address = visitor.project_name + house_name;
                } else if (visitor.employee_type == 2) { // 拜访物业
                    visitor.address = visitor.project_name;
                }
            }

            resolve(visitor);
        }).catch(err => {
            reject(err);
        })
    });
}

// 添加访客
export function addVisitor(projectId, visitor,isNewSeeFlag) {
    let data = Object.assign({...visitor}, {'method': 'POST'});
    let headers = {}
    if(isNewSeeFlag){
        headers = {
            "isNewSee": 1
        }
    }
    return request({
        url: `v2/smart-access/${projectId}/visitor`,
        method: 'post',
        data,
        headers
    })
}

// 修改访客
export function modifyVisitor(projectId, visitorId, visitor) {
    let data = Object.assign(visitor, {'method': 'PUT'});

    return request({
        url: `v2/smart-access/${projectId}/visitor/${visitorId}`,
        method: 'post',
        data
    })
}


// 查询访客列表
export function queryVisitors(projectId, openid) {
    let query = {
        'open_id': {
            '$eq': openid
        },
        'special_flag': {
            '$ne': true
        }
    }

    return request({
        url: `v2/smart-access/${projectId}/visitors`,
        method:'post',
        data: {query, order: {'create_time': 'desc'}, method: 'POST'}
    })
}

// 查询住户列表
export function queryResidents(params) {
    let {
        projectId,
        ...rest
    } = params;
    let data = toAdvancedQuery(rest);
    return request({
        url: `v2/smart-access/${projectId}/residents`,
        method: 'post',
        data: Object.assign(data, {method: 'POST'})
    });
}

// 查询员工列表
export function queryEmployees(projectId, phone) {
    let data = {
        'query': {
            'project_id': {
                '$eq': projectId
            },
            'emp_phone': {
                '$eq': phone
            }
        },
        'method': 'POST'
    }
    return request({
        url: `v2/smart-access/AllowAuthEmployee/getPageData`,
        method: 'post',
        data
    });
}

// 获取访客配置
export function getVisitorConfig(projectId) {
    let data = {
        'method': 'GET'
    }

    return request({
        url: `v2/smart-access/${projectId}/visiting-config-detail`,
        method: 'post',
        data
    })
}

// 获取访客授权门禁
export function getAuthDoors(projectId, residentId, merchant_id, visitor_id) {
    let data = {
        merchant_id,
        visitor_id,

        'limit': 999,
        'method': 'POST'
    }
    let query = {
        'auth_resident_type':{
            '$in':[8]
        },
        'open_mode_cd': {
            '$in':[6, 7]
        }
    }
    if (residentId) {
        Object.assign(query, {'person_id': {
            '$eq': residentId
        }})
    }
    Object.assign(data, {query})
    return request({
        url: `v2/smart-access/${projectId}/access-authorizations`,
        method: 'post',
        data
    })
}

// 远程开门
export function unlockRemoteDoor(projectId, params) {
    let data = Object.assign(params, {'method': 'POST'});

    return request({
        url: `v2/smart-access/${projectId}/unlock/remote`,
        method: 'post',
        data
    })
}

// 获取访客授权梯控
export function getAuthLifts(projectId, residentId, merchant_id) {
    let data = {
        'query': {
            'project_id': projectId,
            'user_id': residentId,
            // 'visitor_id':residentId,
            'user_type': ['VISITOR'],
            type: "VISITOR",
            'call_type': ['LONG_RANGE','BLUETOOTH']
        },
        'page': 1,
        'size': 999,
        'method': 'POST'
    }
    return request({
        url: `v1/xlink-lift-rest/liftAuthorrizeControl/liftAuthorrizeList`,
        method: 'post',
        data
    })
}

// 远程呼梯
export function unlockRemoteLift(params) {
    let data = Object.assign(params, {'method': 'POST'});

    return request({
        url: `v1/xlink-lift-rest/ladder/unlock/remote`,
        method: 'post',
        data
    })
}

// 通行二维码
export function getAccessCode(projectId, visitorId, extend_info) {
    const data = Object.assign(extend_info, {'method': 'POST'});
    return request({
        url: `v2/smart-access/${projectId}/visitor/genqrcode/${visitorId}`,
        method: 'post',
        data
    })
}

export function getFushiCode(projectId, visitorId, extend_info) {
    const data = {'method': 'POST', extend_info};
    return request({
        url: `v2/smart-access/${projectId}/qrcode/visitor/${visitorId}`,
        method: 'post',
        data
    })
}

/**
 * 获取统一开门二维码
 * @param {String} projectId
 * @param {String} personId
 * @param {Object} data
 * data.effective_time: 生效时间（日期类型）
 * data.expired_time: 失效时间（日期类型）
 * data.person_type: 授权类型，1-业主、2-亲属、3-租户、4-业主成员、5-租户成员、6-车位租户、7-员工、8-访客
 */
export function getUniQrcode(projectId, personId, data) {
    Object.assign(data, {'method': 'POST'});

    return request.post(`v2/smart-access/${projectId}/qrcode/all/${personId}`, data, {
        timeout: 20000
    });
}

// 查询住户产权信息
export function getHouseInfo(communityId, mobile, residentId) {
    const data = {communityId, mobile};
    return new Promise((resolve, reject) => {
        request({
            url: 'mid/user/propertyauth/list/by/communityIdAndMobile',
            method: 'post',
            data
        }).then(res => {
            const houses = (res.houses || [])
                .filter(house => house.propertyType == '1' &&
                        house.status == '4' &&
                        house.custId == residentId);
            resolve(houses || {});
        }).catch(err => {
            reject(err);
        })
    });
}

// 获取授权设备
export function getAuthDevices(projectId, params, visitor_id) {
    let options = {
        offset: 0,
        limit: 999
    }
    let data = toAdvancedQuery(params, options);
    data.visitor_id = visitor_id

    return request({
        url: `v2/smart-access/${projectId}/access-authorizations`,
        method: 'post',
        data: Object.assign(data, {method: 'POST'})
    });
}

// 更新访客
export function updateVisitor(params) {
    Object.assign(params, {method: 'POST'});

    return request({
        url: 'v2/smart-access/residents/update',
        method: 'post',
        data: params
    });
}

// 查询访客人脸
export function getFaceMaterial(projectId, personId) {
    const params = {
        query: {
            person_id: {'$eq': personId}
        },
        offset: 0,
        limit: 10,
        method: 'POST',
        order: { create_time: 'desc' }
    };

    return request({
        url: `v2/smart-access/${projectId}/face-recognition/materials`,
        method: 'post',
        data: params
    });
}

// 添加访客人脸
export function addFaceMaterial(projectId, params) {
    Object.assign(params, {method: 'POST'});
    return request({
        url: `v2/smart-access/${projectId}/face-recognition/material`,
        method: 'post',
        data: params
    });
}

// 下发人脸设备
export function addToFaceDevices(paramArr) {
    const params = {
        'body': paramArr,
        'method': 'POST'
    }

    return request({
        url: 'v2/smart-access/face-device/authorization',
        method: 'post',
        data: params
    });
}


export function faceAccessDeviceByPerson(projectId, paramArr) {
    const params = {
        'body': paramArr,
        'method': 'POST'
    }
    return request({
        url: `/v2/smart-access/${projectId}/face-device/reload`,
        method: 'post',
        data: params
    });
}

// 访客人脸照片校验
export function detectFaceContent(base64) {
    const params = {
        'imageType': 1,
        'imageContent': base64
    }

    return request({
        url: 'ai/face/detect',
        method: 'post',
        data: params,
        timeout: 10000
    });
}

export function linkFace(params) {
    return request({
        url: 'ai/face/sync/linkface',
        method: 'post',
        data: params
    });
}

// 云朵2.x获取当前登录用户信息
export function getLoginUserInfo(cookie){
    return request({
        url:'biz/mob/body/getUserId',
        data: { cookie }
    })
}

// 常用访客
// 常用访客列表
export function oftenVisitorList (params) {
    // let params = {
    //     search,
    //     resident_id,
    //     open_id,
    //     method
    // }
    return request({
        url: 'v2/smart-access/visitor-often/list',
        method: 'post',
        data: params
    });
}
// 获取常用访客详情
export function getOftenVisitorById (id) {
    return request({
        url: 'v2/smart-access/visitor-often/getById',
        method: 'post',
        data: {id, method:"POST"}
    });
}
// 删除常用访客
export function deleteOftenVisitor (id) {
    return request({
        url: 'v2/smart-access/visitor-often/delete',
        method: 'post',
        data: {id, method:"POST"}
    });
}
// 更新常用访客
/**
 * {
    "id":83848dd833, //常用访客ID
	"resident_id":"2981875",
	"resident_name":"张禄发",
	"open_id":"abfbs7273727373",
	"name":"张晓明",
	"phoen":"18799880099",
	"face_url":"http://wwww.hhh.sss/face/uuu.png"
    }
 * @param {Object} params
 * @returns
 */
export function updateOftenVisitor (params) {
    return request({
        url: 'v2/smart-access/visitor-often/update',
        method: 'post',
        data: Object.assign(params, {method:"POST"})
    });
}
// 新增常用访客
/**addOftenVisitor
 * {
	"resident_id":"2981875",  //住户ID
	"resident_name":"张禄发", //住户名称
	"open_id":"", //如果是微信端传open_id
	"name":"张晓明", //访客名称
	"phoen":"18799880099", //访客手机号
	"face_url":"http://wwww.hhh.sss/face/uuu.png"  //访客人脸
    }
 * @param {Object} params
 * @returns
 */
export function addOftenVisitor (params) {
    return request({
        url: 'v2/smart-access/visitor-often/add',
        method: 'post',
        data: Object.assign(params, {method:"POST"})
    });
}

/**
 * 判断住户的常用访客手机是否已经存在（新增、更新提交时云端也做了校验）
 * {
        "id": "ba60a5fc4b66618e23289c6abb", //常用访客ID，修改时传，新增没有不传
        "resident_id": "2981875", //住户id
        "phone": "1879988887"  //访客手机号
   }
 * @param {Object} params
 * @returns
 */
export function isOftenVisitor (params) {
    return request({
        url: 'v2/smart-access/visitor-often/isExist',
        method: 'post',
        data: params
    });
}



// 星期转换
export function getWeekDesc(index) {
    const weex = {
        '0': '周日',
        '1': '周一',
        '2': '周二',
        '3': '周三',
        '4': '周四',
        '5': '周五',
        '6': '周六',
    }
    return weex[index];
}

// 星期转换
export function getDayDesc(index) {
    let days = {};
    for(let i = 1; i <=31; i++) {
        days[i] = i + '号'
    }
    return days[index];
}

/** =================================================================
 *  特殊访客接口
 *  =================================================================
 */

export const MerchantType = {
    'MERCHANT': 1,   // 商家
    'INDUVIDUAL': 2  // 个体
}

// 特殊访客周期类型
export const VisitingChart = {
    'SHORT': 1,
    'LONG': 2
}

// 拜访状态枚举
export const MerchantStatus = {
    'REVIEW': 0,   // 待审核
    'EFFECT': 1,   // 待生效
    'EFFECTED': 2, // 已生效
    'EXPIRED': 3,  // 已过期
    'CANCELED': 4, // 已取消
    'DELAYED': 5,  // 已延期
    'REJECTED': 6, // 驳回
}

// 拜访状态字段
export const MerchantStatusObj = {
    [MerchantStatus.REVIEW]: {name: '待审核', type: 'primary', btns: [
        {name: '取消申请', pure: true, method: 'doCancel', includes: [MerchantType.MERCHANT, MerchantType.INDUVIDUAL]}
    ]},
    [MerchantStatus.EFFECT]: {name: '待生效', type: 'primary', btns: [
        {name: '取消申请', pure: true, method: 'doCancel', includes: [MerchantType.MERCHANT, MerchantType.INDUVIDUAL]},
        {name: '再次申请', method: 'doReapply', includes: [MerchantType.MERCHANT]},
        {name: '展示通行证', method: 'toPassport', includes: [MerchantType.INDUVIDUAL]}
    ]},
    [MerchantStatus.EFFECTED]: {name: '已生效', type: 'primary', btns: [
        {name: '取消申请', pure: true, method: 'doCancel', includes: [MerchantType.MERCHANT, MerchantType.INDUVIDUAL]},
        {name: '再次申请', method: 'doReapply', includes: [MerchantType.MERCHANT]},
        {name: '展示通行证', method: 'toPassport', includes: [MerchantType.INDUVIDUAL]}
    ]},
    [MerchantStatus.EXPIRED]: {name: '已过期', type: 'info', btns: [
        {name: '再次申请', method: 'doReapply', includes: [MerchantType.MERCHANT, MerchantType.INDUVIDUAL]},
    ]},
    [MerchantStatus.CANCELED]: {name: '已取消', type: 'info', btns: [
        {name: '再次申请', method: 'doReapply', includes: [MerchantType.MERCHANT, MerchantType.INDUVIDUAL]},
    ]},
    [MerchantStatus.DELAYED]: {name: '已延期', type: 'primary', btns: [
        {name: '取消申请', pure: true, method: 'doCancel', includes: [MerchantType.MERCHANT, MerchantType.INDUVIDUAL]},
        {name: '再次申请', method: 'doReapply', includes: [MerchantType.MERCHANT]},
        {name: '展示通行证', method: 'toPassport', includes: [MerchantType.INDUVIDUAL]}
    ]},
    [MerchantStatus.REJECTED]: {name: '已驳回', type: 'danger', btns: [
        {name: '重新编辑', pure: true, method: 'doReedit', includes: [MerchantType.MERCHANT, MerchantType.INDUVIDUAL]},
    ]}
}

export function isSpecialNegative(status) {
    return MerchantStatus.EXPIRED == status ||
        MerchantStatus.CANCELED == status ||
        MerchantStatus.REJECTED == status;
}

// 获取特殊访客类型
export function getSpecialTypes(projectId, specialFlag = true) {
    let params = {
        offset: 0,
        limit: 100,
        query: {  },
        order: { create_time: "desc" },
        method: 'POST'
    };
        params = Object.assign(params, {query: {special_flag: { $eq: specialFlag }}})


    return request({
        url: `/v2/smart-access/${projectId}/visitor/visiting-settings`,
        method: 'post',
        data: params
    })
}

// 获取特殊访客列表
export function getSpecialList(projectId, openid, merchantFlag) {
    const query = {
        offset: 0,
        limit: 999,
        query: {
            open_id: { $eq: openid },
            merchant_flag: { $eq: parseInt(merchantFlag) }
        },
        order: { create_time: "desc" },
        method: 'POST'
    };

    return request({
        url: `/v2/smart-access/${projectId}/visitor/special/list`,
        method: 'post',
        data: query
    })
}

// 获取特殊访客详情
export function getSpecialDetail(projectId, visitorId) {
    return request({
        url: `/v2/smart-access/${projectId}/visitor/special/${visitorId}`,
        method: 'post',
        data: {method: 'GET'}
    })
}

// 添加特殊访客
export function addSpecialVisitor(projectId, params) {
    return request({
        url: `/v2/smart-access/${projectId}/visitor/special/add`,
        method: 'post',
        data: Object.assign(params, {method: 'POST'})
    })
}

// 更新特殊访客
export function updateSpecialVisitor(projectId, id, params) {
    const data = Object.assign(params, {method: 'PUT'})

    return request({
        url: `/v2/smart-access/${projectId}/visitor/special/update/${id}`,
        method: 'post',
        data: data
    })
}

// 删除特殊访客
export function delSpecialVisitor(projectId, visitorId) {
    return request({
        url: `v2/smart-access/${projectId}/visitor/special/delete/${visitorId}`,
        method: 'post',
        data: {'method': 'DELETE'}
    })
}

// 获取访客列表
export function queryVisitors2(projectId, params={}) {
    let query= {
        "query": {
            'resident_phone': {
                '$eq': params.resident_phone
            }
        },
    }
    return request({
        url: `v2/smart-access/${projectId}/visitors`,
        method: 'post',
        data: Object.assign(query, {method: 'POST'})
    })
}




// WEBPACK FOOTER //
// ./src/api/visitor.js